import { isWebsiteInternallyRouted } from 'src/utils/isWebsiteInternallyRouted';
import { PATH } from 'src/utils/routes';

export const isWebsiteInternallyRoutedSSR = (ctx) => {
  const domain = ctx?.req?.headers?.domain || ctx?.req?.headers?.host;
  return isWebsiteInternallyRouted(domain);
};

export const getBasicWebsiteInfoByCTX = (ctx) => {
  const url = ctx?.req?.url;

  return {
    isInternallyRoutedDomain: isWebsiteInternallyRoutedSSR(ctx),
    isBuilderRoute: !!url?.includes(PATH.WEBSITE_BUILDER),
    isPreviewRoute: !!url?.includes(PATH.BUILDER_PREVIEW),
    isPDPRoute: !!url?.includes(PATH.PDP),
    isDashyThemePreviewLink: !!url?.includes(PATH.DASHY_THEME_PREVIEW),
    domainByParams: ctx?.params?.domain,
    domainByQuery: ctx?.query?.domain,
  };
};
